'use client';
import React__default, { forwardRef } from 'react';
import { classNames } from '../../utils/class-names.mjs';

const Button = forwardRef(
  ({
    variant = "default",
    size = "default",
    disableable = true,
    className,
    ...props
  }, forwardedRef) => {
    return /* @__PURE__ */ React__default.createElement("button", {
      type: "button",
      className: classNames(
        "lb-button",
        !disableable && "lb-button:non-disableable",
        className
      ),
      "data-variant": variant,
      "data-size": size,
      ...props,
      ref: forwardedRef
    });
  }
);

export { Button };
//# sourceMappingURL=Button.mjs.map
